import judgeApplication from '@/api/judgeApplication'
import * as types from '../mutation-types'

const state = {
  judgeApplication: null
}

const getters = {
  judgeApplication: state => state.judgeApplication !== null ? state.judgeApplication : {}
}

const actions = {
  getJudgeApplication ({ commit, state }, { userID }) {
    commit(types.CLEAR_JUDGE_APPLICATION)
    return new Promise((resolve, reject) => {
      judgeApplication.getJudgeApplication(userID).then((response) => {
        const judgeApplication = response.data.result.judgeApplication
        commit(types.SET_JUDGE_APPLICATION_DATA, judgeApplication)
        resolve(judgeApplication)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.SET_JUDGE_APPLICATION_DATA] (state, judgeApplication) {
    state.judgeApplication = judgeApplication
  },
  [types.CLEAR_JUDGE_APPLICATION] (state) {
    state.judgeApplication = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
